import { BrowserRouter as Router } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";

import "App.scss";
import "react-toastify/dist/ReactToastify.css";
import Routers from "router";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

export function App() {
	return (
		<Router>
			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				closeButton={false}
				rtl={false}
				pauseOnFocusLoss
				draggable={false}
				pauseOnHover={false}
				theme="dark"
				transition={Slide}
			/>
			<Routers />
		</Router>
	);
}
